import { cva } from 'class-variance-authority';

export const headingStyles = cva('pt-4 font-bold first:pt-0', {
  variants: {
    type: {
      h1: 'text-rich-h1',
      h2: 'text-rich-h2',
      h3: 'text-rich-h3',
      h4: 'text-rich-h4',
      h5: 'text-rich-h5',
      h6: 'text-rich-h6',
    },
  },
  defaultVariants: {
    type: 'h2',
  },
});
